import { render, staticRenderFns } from "./CollegeEmployer.vue?vue&type=template&id=4008ac40"
import script from "./CollegeEmployer.vue?vue&type=script&lang=js"
export * from "./CollegeEmployer.vue?vue&type=script&lang=js"
import style0 from "./CollegeEmployer.vue?vue&type=style&index=0&id=4008ac40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports